export default __webpack_public_path__ + "static/font-f5cc9e07041538d37055d441117c6957.ttf";